import eyecare from "assets/images/banners/home/optho.png";
import aboutus from "assets/images/banners/about/optho.png";
import facility from "assets/images/banners/facility/optho.png";
import facility2 from "assets/images/banners/facility/wavelight.png";
import info from "assets/images/banners/info/optho.png";

export const data = {
  id: "department", 
  label: "Ophthalmology",
  banner: "Best Eye Specialists in Chennai - Advanced Ophthalmology Care || Restoring Vision, Transforming Lives",
  bannerSize: ["4.375rem", "2.375rem"],
  bannerImg: eyecare,
  aboutImg: aboutus,
  title: "Best Eye Specialists in Chennai with Advanced Eye Care Services",
  description: "Looking for the best eye specialists in Chennai? Visit Amrit Hospitals for expert ophthalmologists, modern eye treatments and personalized vision care.",
  keyword: "eye specialist in Chennai, ophthalmologist in chennai, best ophthalmologist in chennai, best eye specialist in chennai, chennai eye specialist hospital, eye doctor in chennai, best eye doctor in chennai, best glaucoma specialist in india, best eye specialist in india, best eye doctor in india, top ophthalmologist in india, best cornea specialist in india, eye specialist in india",
  url: "https://www.amrithospitals.com/department/ophthalmology",
  Imageme: "https://www.amrithospitals.com/static/media/optho.966f29f85f82f47f8c43.png",
  about: [ 
    {
      text: "40+",
      subText: "Years of Experience",
    },
    {
      text: "2 Lac+",
      subText: "Surgeries",
    },
    {

      text: "4.8 Lac+",
      subText: "Happy Patients",
    },
    {
      text: "25000+", 
      subText: "Specs Removed",
    },
  ],
  facilityImg: facility,
  facilityImgAlt:"Best eye specialist in Chennai providing advanced ophthalmology treatment at Amrit Hospitals",
  infoImg: info,
  info: {
    heder: "Powered By",
    subheader: "Artificial Intelligence",
    point1: "NO BLADE, NO PAIN",
    point2: "NO STITCH, NO INJECTION",
  },
  facility: {
    mainHeader: "Freedom From Glasses In Just 9 Seconds",
    subHeader: "Smile Pro Surgery can be life changing",
    content:
      "Dreamed of becoming a pilot, a model, or anything you've ever desired? Our best eye doctors in Chennai can help you achieve just that. In just 9 seconds, Smile Pro Surgery removes your specs and changes your life forever. Embrace a future of limitless possibilities with crystal-clear vision!",
  },
  facilityImg2: facility2,
facilityImg2Alt:"Advanced WaveLight laser technology for vision correction by top ophthalmologists in Chennai",

  facility2: {
    mainHeader: "AI-Guided, Ultra Fast, Pain-Free Vision Correction",
    subHeader: "Advanced WaveLight laser technology for vision correction by top ophthalmologists in Chennai",
    content:
      "Tired of depending on glasses or contact lenses? As the best eye specialist in Chennai, Amrit Hospitals offers vision correction in just 15 seconds per eye with an AI-guided laser procedure that delivers unmatched precision and safety. Experience faster recovery and clearer sight — all within 24 hours.",
  },
  serviceHeader: "Super-Specialty Eye Care in Chennai",
  services: [

    {
      id: "WaveLightPlusInnovEyesTechnology",
      label: "WaveLight Plus InnovEyes Technology",
      content:
        "Step into the future of eye health with AI-guided vision correction that combines speed, precision, and comfort. Our eye specialists in Chennai use this advanced technology for unmatched results.",
        customLink: "/department-internal/ophthalmology/wavelight-plus",
    },
    {
      id: "smileProSurgery",
      label: "Smile Pro Surgery",
      content:
        "Experience the world's first robotic, flapless, and minimally invasive laser vision correction procedure, restoring perfect vision in just 9 seconds — performed by the best ophthalmologists in Chennai.",
    },
    {
      id: "contouraVision",
      label: "Contoura Vision in Chennai – Advanced LASIK Eye Surgery",
      content:
        "Achieve superior visual acuity with this advanced LASIK technique. Our best eye doctors in Chennai customize treatment based on the microscopic contours of your cornea",
    },
    {
      id: "cataract",
      label: "Cataract",
      content:
        "Restore clarity and improve vision with advanced cataract surgery by our experienced eye specialists in Chennai, ensuring a brighter, clearer future.",
    },
    {
      id: "glaucoma",
      label: "Glaucoma",
      content:
        "Protect your vision with our comprehensive glaucoma management and treatment plans, tailored to prevent and control eye pressure.",
    },
    {
      id: "corneaAndKeratoconus",
      label: "Cornea Specialist & Keratoconus Treatment in Chennai",
      content:
        "Specialized care for corneal diseases and keratoconus, offering treatments to improve corneal health and visual outcomes.",
    },
    {
      id: "pediatricOphthalmology",
      label: "Pediatric Ophthalmology",
      content:
        "Dedicated eye care for children, addressing vision issues early to ensure optimal eye health and development.",
    },
    {
      id: "retina",
      label: "Retina",
      content:
        "Advanced diagnostic and treatment options for retinal conditions, preserving and enhancing your vision with cutting-edge care.",
    },
    {
      id: "oculoplastyAndCosmeticEnhancement",
      label: "Oculoplasty and Cosmetic Enhancement",
      content:
        "Enhance your appearance and eye function with our expert oculoplastic and cosmetic procedures.",
    },
    {
      id: "contactLenses",
      label: "Contact Lenses",
      content:
        "Find the perfect contact lenses to suit your lifestyle and visual needs, with personalized fitting and care.",
    },
    {
      id: "neuroOphthalmology",
      label: "Neuro Ophthalmology",
      content:
        "Specialized care for complex eye conditions related to the nervous system, ensuring comprehensive diagnosis and treatment.",
    },
    {
      id: "lowVisionSyndrome",
      label: "Low Vision Syndrome",
      content:
        "Customized solutions to improve quality of life and maximize remaining vision for those with low vision syndrome.",
    },
  ],
faqsSection: {
    heading: "Frequently Asked Questions About Eye Specialists in Chennai",
    services: [
      {
        label: "1. Why choose Amrit Hospitals for the best eye specialists in Chennai?",
        content:
          "Amrit Hospitals is home to some of the best eye specialists in Chennai, offering advanced ophthalmology care supported by modern diagnostic technology. Our experienced ophthalmologists provide accurate diagnosis and personalized eye treatments.",
      },
      {
        label: "2. What eye care services are offered by the best ophthalmologists in Chennai at Amrit Hospitals?",
        content:
          "Our ophthalmology department in Chennai provides complete eye care services including eye examinations, vision correction, cataract treatment, LASIK surgery, and advanced diagnostics for various eye conditions.",
      },
      {
        label: "3. Can the best eye doctor in Chennai at Amrit Hospitals treat eye emergencies?",
        content:
          "Yes, our experienced eye doctors are equipped to handle eye emergencies with prompt diagnosis and advanced treatment. Immediate care helps protect vision and prevent long-term complications.",
      },
      {
        label: "4. How do eye specialists at Amrit Hospitals ensure safe eye treatments?",
        content:
          "Our best ophthalmologists follow strict clinical protocols and use advanced surgical technology for safe and effective eye treatments. Comprehensive evaluation and post-treatment care ensure the best outcomes.",
      },
      {
        label: "5. Are advanced diagnostic facilities available for eye conditions in Chennai?",
        content:
          "Yes, Amrit Hospitals offers modern eye diagnostic technology in Chennai to detect and evaluate eye diseases early. This allows our eye specialists to provide precise and personalized treatment plans.",
      },
      {
        label: "6. What is the cost of LASIK in Chennai?",
        content:
          "The cost depends on the type of LASIK procedure and individual eye condition. A consultation helps determine the exact treatment plan.",
      },
      {
        label: "7. How can I book an appointment with the best eye specialists in Chennai at Amrit Hospitals?",
        content:
          "You can easily book an appointment with our best ophthalmologists in Chennai through the online booking system or by contacting Amrit Hospitals directly for consultation scheduling.",
      },
       {
        label: "8. Are the results of LASIK permanent?",
        content:
          "LASIK provides long-lasting vision correction. However, natural age-related changes in vision may still occur over time.",
      },
    ],
  },
  faqSchema: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Why choose Amrit Hospitals for the best eye specialists in Chennai?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Amrit Hospitals is home to some of the best eye specialists in Chennai, offering advanced ophthalmology care supported by modern diagnostic technology. Our experienced ophthalmologists provide accurate diagnosis and personalized eye treatments.",
        },
      },
      {
        "@type": "Question",
        "name": "What eye care services are offered by the best ophthalmologists in Chennai at Amrit Hospitals?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our ophthalmology department in Chennai provides complete eye care services including eye examinations, vision correction, cataract treatment, LASIK surgery, and advanced diagnostics for various eye conditions.",
        },
      },
      {
        "@type": "Question",
        "name": "Can the best eye doctor in Chennai at Amrit Hospitals treat eye emergencies?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, our experienced eye doctors are equipped to handle eye emergencies with prompt diagnosis and advanced treatment. Immediate care helps protect vision and prevent long-term complications.",
        },
      },
      {
        "@type": "Question",
        "name": "How do eye specialists at Amrit Hospitals ensure safe eye treatments?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Our best ophthalmologists follow strict clinical protocols and use advanced surgical technology for safe and effective eye treatments. Comprehensive evaluation and post-treatment care ensure the best outcomes.",
        },
      },
      {
        "@type": "Question",
        "name": "Are advanced diagnostic facilities available for eye conditions in Chennai?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, Amrit Hospitals offers modern eye diagnostic technology in Chennai to detect and evaluate eye diseases early. This allows our eye specialists to provide precise and personalized treatment plans.",
        },
      },
      {
        "@type": "Question",
        "name": "What is the cost of LASIK in Chennai?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The cost depends on the type of LASIK procedure and individual eye condition. A consultation helps determine the exact treatment plan.",
        },
      },
      {
        "@type": "Question",
        "name": "How can I book an appointment with the best eye specialists in Chennai at Amrit Hospitals?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can easily book an appointment with our best ophthalmologists in Chennai through the online booking system or by contacting Amrit Hospitals directly for consultation scheduling.",
        },
      },
      {
        "@type": "Question",
        "name": "Are the results of LASIK permanent?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "LASIK provides long-lasting vision correction. However, natural age-related changes in vision may still occur over time.",
        },
      },
    ],
  },
  breadcrumbSchema: {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.amrithospitals.com/",
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Ophthalmology",
        "item": "https://www.amrithospitals.com/department/ophthalmology",
      },
    ],
  },
};


